"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Utils = tslib_1.__importStar(require("../util/utils"));
var eventemitter_1 = tslib_1.__importDefault(require("../util/eventemitter"));
var connectionmanager_1 = tslib_1.__importDefault(require("../transport/connectionmanager"));
var logger_1 = tslib_1.__importDefault(require("../util/logger"));
var connectionstatechange_1 = tslib_1.__importDefault(require("./connectionstatechange"));
function noop() { }
var Connection = /** @class */ (function (_super) {
    tslib_1.__extends(Connection, _super);
    function Connection(ably, options) {
        var _this = _super.call(this) || this;
        _this.whenState = (function (state, listener) {
            return eventemitter_1["default"].prototype.whenState.call(_this, state, _this.state, listener, new connectionstatechange_1["default"](undefined, state));
        });
        _this.ably = ably;
        _this.connectionManager = new connectionmanager_1["default"](ably, options);
        _this.state = _this.connectionManager.state.state;
        _this.key = undefined;
        _this.id = undefined;
        _this.serial = undefined;
        _this.timeSerial = undefined;
        _this.recoveryKey = undefined;
        _this.errorReason = null;
        _this.connectionManager.on('connectionstate', function (stateChange) {
            var state = (_this.state = stateChange.current);
            Utils.nextTick(function () {
                _this.emit(state, stateChange);
            });
        });
        _this.connectionManager.on('update', function (stateChange) {
            Utils.nextTick(function () {
                _this.emit('update', stateChange);
            });
        });
        return _this;
    }
    Connection.prototype.connect = function () {
        logger_1["default"].logAction(logger_1["default"].LOG_MINOR, 'Connection.connect()', '');
        this.connectionManager.requestState({ state: 'connecting' });
    };
    Connection.prototype.ping = function (callback) {
        logger_1["default"].logAction(logger_1["default"].LOG_MINOR, 'Connection.ping()', '');
        if (!callback) {
            if (this.ably.options.promises) {
                return Utils.promisify(this, 'ping', arguments);
            }
            callback = noop;
        }
        this.connectionManager.ping(null, callback);
    };
    Connection.prototype.close = function () {
        logger_1["default"].logAction(logger_1["default"].LOG_MINOR, 'Connection.close()', 'connectionKey = ' + this.key);
        this.connectionManager.requestState({ state: 'closing' });
    };
    return Connection;
}(eventemitter_1["default"]));
exports["default"] = Connection;
